module.exports = __webpack_public_path__ + "res/img/kq.42ecab4b.png";